module.exports = __webpack_public_path__ + "img/6.a8de2f85.jpeg";